export const copyright_policy = `<h1>저작권보호정책</h1>
<p style="margin-top: 15px">
    저작권정책은 퍼스널뉴스서비스(이하 회사)가 제공하는 모든 서비스내 저작물을 이용자가 이용함에 있어 저작권법 및 기타 법령을 준수한 올바른 이용방법, 기타 필요한 사항을 규정함을 목적으로 합니다.
</p>
<ul style="margin-top: 15px">
    <li>1 조 <strong>저작권정책의 고지</strong></li>
    <li>2 조 <strong>이용자의 의무</strong></li>
    <li>3 조 <strong>저작권 침해 게시물에 대한 조치</strong></li>
    <li>4 조 <strong>게시 재개 요청</strong></li>
</ul>
<h2 style="margin-top: 15px">제 1 조 저작권정책의 고지</h2>
<ol>
    <li>회사는 저작권법 및 기타 법령을 준수합니다.</li>
    <li>회사의 서비스에서 제공되는 모든 콘텐츠(기사, 사진, 그래픽, 영상, 오디오, 첨부파일, DB정보 등)는 저작권법에 의하여 보호받는 저작물로써 별도의 저작권 표시 또는 다른 출처를 명시한 경우를 제외하고는 원칙적으로 회사에 저작권이 있습니다.</li>
    <li>이용자가 직접 작성하여 해당 저작권이 이용자에게 귀속되는 콘텐츠와 적법한 절차에 따라 저작권 이용허락을 받은 후 저작권 및 출처가 표시된 저작물은 회사의 저작물에서 제외합니다.</li>
    <li>회사는 서비스 내 게시물이 저작권 및 기타 타인의 권리를 침해 하거나, 회사의 정책 또는 관련 법령에 위배된다고 인지한 경우 게시물을 삭제할 수 있습니다.</li>
</ol>

<h2 style="margin-top: 15px">제 2 조 이용자의 의무</h2>
<ol>
    <li>이용자는 저작권법 및 기타 법령 등을 준수할 의무가 있으며, 위반 시 이용이 일시 또는 영구 정지될 수 있습니다.</li>
    <li>서비스 내 모든 저작물은 회사의 승낙 없이 복제, 출판, 전송, 배포, 판매, 변형, 방송 등의 행위를 금지합니다.</li>
    <li>회사의 승낙을 받은 후 해당 저작물을 이용하는 경우에도 저작물에 대하여 단순 오류 정정 이외의 무단 변경을 금지하며 반드시 출처를 표시해야 합니다.</li>
</ol>

<h2 style="margin-top: 15px">제 3 조 저작권 침해 게시물에 대한 조치</h2>
<ol>
    <li>이용자가 올린 게시물(의견, 댓글, 질문, 영상, 파일, 링크 등)에 대한 권리는 권리자에게 있으며 관련하여 문제가 발생할 경우에는 그에 대한 책임은 해당 이용자에게 있습니다.
        저작권법 및 기타 법령을 위반한 게시물에 대하여 회사는 게시 중단 및 삭제할 수 있습니다.</li>
    <li>서비스 내에서 자신의 저작권이 침해당했다고 주장하는 권리자는 그 저작물의 게시 중단 및 삭제를 요청할 수 있습니다.</li>
    <li>반복적으로 저작권 등 법령을 침해하는 이용자는 그 계정의 사용을 중단할 수 있습니다.</li>
</ol>

<h2 style="margin-top: 15px">제 4 조 게시 재개 요청</h2>
<p>저작권 침해 신고로 인해 게시 중단 및 삭제 통보를 받은 이용자는 소명자료를 제출하여 그 재개를 요청할 수 있습니다.</p>`
